export default function youtubePopup($) {
    const openButtons = $('[data-js="yt-popup-open"]');

    if (!openButtons.length) return;

    openButtons.each(function () {
        const $btn = $(this);
        const $popup = $btn.closest('.big-header').find('[data-js="yt-popup"]');
        const $iframe = $popup.find('iframe');
        const $closeButtons = $popup.find('[data-js="yt-popup-close"]');

        $btn.on('click', function () {
            // Load the iframe src the first time it's opened
            if (!$iframe.attr('src')) {
                $iframe.attr('src', $iframe.data('src'));
            }
            $popup.addClass('open').attr('aria-hidden', 'false');
            $('body').css('overflow', 'hidden');
        });

        $closeButtons.on('click', function () {
            closePopup($popup, $iframe);
        });

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape' && $popup.hasClass('open')) {
                closePopup($popup, $iframe);
            }
        });
    });

    function closePopup($popup, $iframe) {
        $popup.removeClass('open').attr('aria-hidden', 'true');
        $('body').css('overflow', '');

        // Stop the video by removing src and restoring it
        const src = $iframe.attr('src');
        $iframe.attr('src', '');
        // Restore so it can be re-opened without a page reload
        setTimeout(function () {
            $iframe.data('src', src || $iframe.data('src'));
        }, 100);
    }
}
